import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { useTranslation } from "react-i18next";
import { Grid, Chip } from "@material-ui/core";

import { styles } from "./Weekdays.styles";

function Weekdays({ classes, edit, weekdays, onChange }) {
  const [selectedWeekdays, setSelectedWeekdays] = useState([]);
  const { t } = useTranslation();
  const wd = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const onWeekdayClick = (d) => {
    setSelectedWeekdays((state) =>
      state.find((item) => item === d)
        ? [...state.filter((item) => item !== d)]
        : [...state.filter((item) => item !== d), d]
    );
  };

  useEffect(() => {
    setSelectedWeekdays(weekdays.split(",").map((item) => item.trim()));
    // eslint-disable-next-line
  }, [weekdays]);

  useEffect(() => {
    onChange && onChange(selectedWeekdays.join(', '));
    // eslint-disable-next-line
  }, [selectedWeekdays])

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {wd.map((d) => {
          return (
            <Grid item key={"week_" + d}>
              <Chip
              className={classes.chip}
                color="primary"
                size="small"
                variant={selectedWeekdays.find((item) => item === d) ? "default" : "outlined"}
                label={t("common.enum.weekdays." + d)}
                onClick={edit ? () => onWeekdayClick(d) : null}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default withStyles(styles)(Weekdays);
